import Axios from 'axios';

Axios.defaults.baseURL = 'https://api.marinersforex.com/api';

export const axiosInstance = Axios.create({});
